<div class="table-container">
  <table class="table">
    <thead>
      <tr>
        <th>Material</th>
        <th class="centralized-content">Quantidade solicitada</th>
        <th class="centralized-content">Estoque</th>
      </tr>
    </thead>
    @if (listAdditionalItems && listAdditionalItems.length > 0) {
      <tbody>
        @for (item of listAdditionalItems; track item) {
          <tr>
            <td [ngClass]="{'error-data': !item.additionalItemForPrescriptionRelease.storageBatch}">{{item.additionalItemForPrescriptionRelease.itemName}}</td>
            <td class="centralized-content" [ngClass]="{'error-data': !item.additionalItemForPrescriptionRelease.storageBatch}">{{item.additionalItemForPrescriptionRelease.numberOfItens}}</td>
            <td class="centralized-content">{{item.additionalItemForPrescriptionRelease.storageBatch}}</td>
          </tr>
        }
      </tbody>
    }
    @if (listAdditionalMedicines && listAdditionalMedicines.length > 0) {
      <tbody>
        @for (medicine of listAdditionalMedicines; track medicine) {
          <tr>
            <td [ngClass]="{'error-data': !medicine.additionalMedicineForPrescriptionRelease.storageBatch}">{{medicine.additionalMedicineForPrescriptionRelease.medicineDescription}}</td>
            <td class="centralized-content" [ngClass]="{'error-data': !medicine.additionalMedicineForPrescriptionRelease.storageBatch}">{{medicine.additionalMedicineForPrescriptionRelease.numberOfItens}}</td>
            <td class="centralized-content">{{medicine.additionalMedicineForPrescriptionRelease.storageBatch}}</td>
          </tr>
        }
      </tbody>
    }
  </table>
</div>